import type { WalletData } from '../../../../queries/walletQuery';

const clamp = (value: number, lower: number, upper: number): number => {
	return Math.min(Math.max(value, lower), upper);
};

const AUTH_PADDING_PERCENTAGE = 7; // default auth padding percentage CHECK

export const getRemainingValue = (card): number => {
	const limit = Number(card.amount);
	return limit - getSpentAmount(card);
};

export const getSpentAmount = (card): number => {
	const fieldAuthPadding = Number(card.authPaddingPercentage);
	const authPaddingPercentage = Number.isNaN(Number(fieldAuthPadding)) ? AUTH_PADDING_PERCENTAGE : fieldAuthPadding;
	if (typeof card.balance !== 'number') {
		return 0;
	}

	return (Number(card.amount) * (100 + authPaddingPercentage)) / 100 - card.balance;
};

export const getSpentPercentage = (card): number => {
	const spent = getSpentAmount(card);
	const limit = Number(card.amount);
	const percentage = (spent / limit) * 100;
	return clamp(Math.round(percentage), 0, 100);
};

export const validateFileSize = ({ file, maxSizeMB }) => {
	const maxSizeBytes = maxSizeMB * 1024 * 1024;
	return file.size <= maxSizeBytes;
};

export const validateFileType = ({ file }) => {
	const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg|\.webp|\.pdf)$/i;
	return allowedExtensions.test(file.name) ? true : false;
};

export function getCardAddressData(card: WalletData['card'] | undefined) {
	if (card && 'billingAddress' in card) {
		const city = card?.billingAddress?.city || '';
		const zipCode = card?.billingAddress?.zipCode || '';
		const address = card?.billingAddress?.address || card?.billingAddress?.addressLine1 || '';
		const addressCode = card?.billingAddress?.regionCode || card?.billingAddress?.region || '';
		const fullAddress = `${city} ${addressCode} ${zipCode}`;
		return { address, fullAddress, city, zipCode, addressCode };
	}
	return { address: '', fullAddress: '', city: '', zipCode: '', addressCode: '' };
}
